var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { WhiteLabel, WhiteLabelIncludes } from '@/models/WhiteLabel';
import { Branding } from '@/models/Branding';
import { School } from '@/models/School';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { fileToBase64 } from '@/support/String';
import { RolesEnum } from '@/items/Roles';
let WhitelabelDetail = class WhitelabelDetail extends Vue {
    constructor() {
        super(...arguments);
        this.whiteLabel = null;
        this.isLoading = true;
        this.isSaving = false;
        this.logoLoadError = false;
        this.isAddingSchool = false;
        this.isLoadingSchools = false;
        this.availableSchools = [];
        this.selectedSchool = null;
        this.menuTabOptions = [
            { key: 'dashboard', label: 'MijnDashboard', icon: 'home' },
            { key: 'plp', label: 'MijnPLP', icon: 'grid_on' },
            { key: 'users', label: 'MijnGebruikers', icon: 'people' },
            { key: 'basis', label: 'MijnBasis', icon: 'public' },
            { key: 'groups', label: 'MijnGroepen', icon: 'groups' },
            { key: 'settings', label: 'MijnInstellingen', icon: 'settings' },
            { key: 'messages', label: 'MijnBerichten', icon: 'chat' },
            { key: 'logs', label: 'Logs', icon: 'list' },
        ];
        this.logoChanged = false;
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        try {
            this.whiteLabel = await new WhiteLabel().include([WhiteLabelIncludes.SCHOOLS]).find(this.$route.params.id);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    isTabEnabled(key) {
        if (!this.whiteLabel || !this.whiteLabel.menu_tabs) {
            return true;
        }
        return this.whiteLabel.menu_tabs.includes(key);
    }
    toggleTab(key) {
        if (!this.whiteLabel)
            return;
        if (!this.whiteLabel.menu_tabs) {
            this.whiteLabel.menu_tabs = this.menuTabOptions.map((t) => t.key).filter((k) => k !== key);
        }
        else if (this.whiteLabel.menu_tabs.includes(key)) {
            this.whiteLabel.menu_tabs = this.whiteLabel.menu_tabs.filter((k) => k !== key);
        }
        else {
            this.whiteLabel.menu_tabs = [...this.whiteLabel.menu_tabs, key];
        }
    }
    get isHelpdeskEnabled() {
        return !!(this.whiteLabel && this.whiteLabel.helpdesk_url);
    }
    toggleHelpdesk() {
        if (!this.whiteLabel)
            return;
        if (this.whiteLabel.helpdesk_url) {
            this.whiteLabel.helpdesk_url = '';
            this.whiteLabel.helpdesk_label = '';
        }
        else {
            this.whiteLabel.helpdesk_url = 'https://';
            this.whiteLabel.helpdesk_label = 'Helpdesk';
        }
    }
    async onLogoChanged(event) {
        if (!event.target?.files?.length || !this.whiteLabel)
            return;
        this.whiteLabel.logo_url = await fileToBase64(event.target.files[0]);
        this.logoLoadError = false;
        this.logoChanged = true;
    }
    get logoPreviewSrc() {
        if (this.logoLoadError)
            return '';
        return (this.whiteLabel && this.whiteLabel.logo_url) || '';
    }
    async save() {
        if (!this.whiteLabel)
            return;
        this.isSaving = true;
        try {
            const payload = {
                color_primary: this.whiteLabel.color_primary,
                color_secondary: this.whiteLabel.color_secondary,
                helpdesk_label: this.whiteLabel.helpdesk_label,
                helpdesk_url: this.whiteLabel.helpdesk_url,
                menu_tabs: this.whiteLabel.menu_tabs,
            };
            if (this.logoChanged) {
                payload.logo_url = this.whiteLabel.logo_url;
            }
            this.whiteLabel = await new WhiteLabel({ id: this.whiteLabel.id }).put(payload);
            this.logoChanged = false;
            this.refreshBranding();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isSaving = false;
        }
    }
    async refreshBranding() {
        try {
            const branding = await Branding.fetch();
            this.$store.dispatch('loadedBranding', branding);
            Branding.apply(branding);
        }
        catch {
            // silent
        }
    }
    get whitelabelSchools() {
        return (this.whiteLabel && this.whiteLabel.schools) || [];
    }
    get schoolHeaders() {
        return [
            { text: 'Naam', value: 'name' },
            { text: '', value: 'actions', width: '50px', align: 'right' },
        ];
    }
    async fetchAvailableSchools() {
        this.isLoadingSchools = true;
        try {
            this.availableSchools = await new School().limit(500).all();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoadingSchools = false;
        }
    }
    async attachSchool() {
        if (!this.selectedSchool || !this.whiteLabel)
            return;
        try {
            await new WhiteLabel({ id: this.whiteLabel.id }).attachSchools([this.selectedSchool.id]);
            this.isAddingSchool = false;
            this.selectedSchool = null;
            this.initialize();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    onClickDetachSchool(school) {
        this.$store.dispatch('openDialog', {
            title: 'Bevestiging',
            text: `Weet je zeker dat je "${school.name}" wilt ontkoppelen?`,
            type: 'warning',
            buttons: {
                confirm: {
                    text: 'Ontkoppelen',
                    action: async () => {
                        try {
                            await new WhiteLabel({ id: this.whiteLabel.id }).detachSchools([school.id]);
                            this.initialize();
                        }
                        catch (error) {
                            ErrorHandler.network(error);
                        }
                    },
                },
                cancel: {
                    text: 'Annuleren',
                },
            },
        });
    }
    onIsAddingSchoolChanged(value) {
        if (value) {
            this.fetchAvailableSchools();
        }
    }
    get canEdit() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    get breadcrumbs() {
        return [
            { name: 'Instellingen', path: '/admin' },
            { name: 'Whitelabel', path: '/admin/whitelabels' },
            { name: this.whiteLabel ? `.${this.whiteLabel.domain || this.whiteLabel.slug}` : '' },
        ];
    }
    get pageTitle() {
        if (!this.whiteLabel)
            return 'Whitelabel';
        const domain = this.whiteLabel.domain || this.whiteLabel.slug;
        return `Whitelabel — .${domain}`;
    }
};
__decorate([
    Watch('isAddingSchool'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WhitelabelDetail.prototype, "onIsAddingSchoolChanged", null);
WhitelabelDetail = __decorate([
    Component({})
], WhitelabelDetail);
export default WhitelabelDetail;
